import React from 'react';
import classNames from 'classnames';
import HrbTranslate from "../language/HrbTranslate";
import './TextFormInputField.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';


const InputFieldBaseHOC = (WrappedComponent) => {
    return class extends React.Component {
        render() {
            let { labelKey, subtextKey, errorKey, extraErrorContent, isDisabled, hideIndicator, titleIndicator } = this.props;
            return (
                <div className={classNames('hrb-text-form-input-container', { "with-errors": Boolean(errorKey), "is-disabled": isDisabled === true })}>
                    <h3>
                        {errorKey && Boolean(titleIndicator) &&
                            <FontAwesomeIcon icon={faExclamationCircle} />
                        }
                        <HrbTranslate text={labelKey} />
                    </h3>
                    <div className='hrb-text-form-input'>
                        <WrappedComponent {...this.props} />
                        {errorKey && !Boolean(hideIndicator) && !Boolean(titleIndicator) &&
                            <div className='hrb-text-form-error-exclam'>
                                <FontAwesomeIcon icon={faExclamationCircle} />
                            </div>
                        }
                    </div>
                    {(subtextKey && !errorKey) &&
                        <div className='hrb-text-form-input-subtext'>
                            <HrbTranslate text={subtextKey} />
                        </div>
                    }
                    {errorKey &&
                        <div className='hrb-text-form-input-error'>
                            <span>
                                <HrbTranslate text={errorKey} />
                                {extraErrorContent}
                            </span>
                        </div>
                    }
                </div>
            );
        }
    }
}

export default InputFieldBaseHOC;
